// app/javascript/landing/sections/ClientsStrip.tsx
import React from "react";
import { Section } from "../components/Section";
import { motion, Transition, Variants } from "framer-motion";

const transition: Transition = { duration: 1, ease: [0.25, 0.1, 0.25, 1] };
const variants: Variants = {
  hidden: { filter: "blur(10px)", transform: "translateY(20%)", opacity: 0 },
  visible: { filter: "blur(0)", transform: "translateY(0)", opacity: 1 },
};

import type { RouteKey } from "../components/Navbar";

type PortfolioTeaserSectionProps = {
  onNavigate?: (route: RouteKey, href: string) => void;
};

export function PortfolioTeaser({ onNavigate }: PortfolioTeaserSectionProps) {
  return (
    <motion.div
      className="x-bg-red-400 x-min-h-[clamp(560px,60dvh,880px)] x-md:min-h-[clamp(560px,100dvh,880px)] flex flex-col justify-center"
      initial="hidden"
      whileInView="visible"
      transition={{ staggerChildren: 0.1 }}
    >
      {/* Encabezado */}
      <div className="max-w-6xl mx-auto px-4 space-y-18">
        <div className="text-center space-y-1">
          <motion.p
            className="text-xl md:text-2xl text-purple-3"
            transition={transition}
            variants={variants}
          >
            Descrube nuestros últimos
          </motion.p>
          <motion.h2
            className="text-4xl md:text-5xl font-bold text-purple-3"
            transition={transition}
            variants={variants}
          >
            Trabajos
          </motion.h2>
        </div>

        <motion.div
          variants={variants}
          className="overflow-hidden rounded-3xl border border-purple-3/15 bg-black/5"
        >
          <img
            src="/landing/portfolio/teaser-main.png" // ⚠️ ajusta ruta/nombre
            alt="Últimos proyectos del Metaverso de la Construcción"
            className="w-full h-64 md:h-80 lg:h-96 object-cover"
          />
        </motion.div>

        {/* Botón */}
        <motion.div variants={variants} className="mt-8 flex justify-center">
          <a
            href="/portafolio"
            className="btn-landing"
            onClick={(e) => {
              if (onNavigate) {
                e.preventDefault();
                onNavigate("portafolio", "/portafolio");
              }
            }}
          >
            Ver portafolio
          </a>
        </motion.div>
      </div>
    </motion.div>
  );
}
